import React from 'react';
import EnhancedTable from './EnhancedTable';

function ClassList(props) {
  return (
    <div className="class-list">
      {
        <EnhancedTable
          rows={props.classes}
          selected={props.selectedClasses}
          setSelected={props.setSelectedClasses}
        />
      }
    </div>
  );
}

export default ClassList;
